import React from 'react'
import ProductsList from './List'
import { Layout } from 'antd'
import Header from '../../../../Header'

const { Content } = Layout

const Products = (props) => {
  const id = props.match.params.id
  const trade = props.match.params.trade

  return (
    <Layout className='layout'>
      <Header item='branch' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <ProductsList id={id} trade={trade} />
        </div>
      </Content>
    </Layout>
  )
}

export default Products
